"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ethereumCrossChainContractsLoader = exports.loadEthereumCoreContracts = exports.ethereumAddressFromSigner = exports.chainIdFromSigner = void 0;
const contracts_1 = require("../contracts");
const ethers_1 = require("ethers");
const bridge_1 = require("./bridge");
const wallet_registry_1 = require("./wallet-registry");
const tbtc_token_1 = require("./tbtc-token");
const tbtc_vault_1 = require("./tbtc-vault");
const address_1 = require("./address");
const l1_bitcoin_depositor_1 = require("./l1-bitcoin-depositor");
__exportStar(require("./address"), exports);
__exportStar(require("./bridge"), exports);
__exportStar(require("./depositor-proxy"), exports);
__exportStar(require("./l1-bitcoin-depositor"), exports);
__exportStar(require("./tbtc-token"), exports);
__exportStar(require("./tbtc-vault"), exports);
__exportStar(require("./wallet-registry"), exports);
/**
 * Resolves the chain ID from the given signer.
 * @param signer The signer whose chain ID should be resolved.
 * @returns Chain ID as a string.
 */
async function chainIdFromSigner(signer) {
    let chainId;
    if (ethers_1.Signer.isSigner(signer)) {
        chainId = await signer.getChainId();
    }
    else {
        const network = await signer.getNetwork();
        chainId = network.chainId;
    }
    return chainId.toString();
}
exports.chainIdFromSigner = chainIdFromSigner;
/**
 * Resolves the Ethereum address tied to the given signer. The address
 * cannot be resolved for signers that works in the read-only mode
 * @param signer The signer whose address should be resolved.
 * @returns Ethereum address or undefined for read-only signers.
 * @throws Throws an error if the address of the signer is not a proper
 *         Ethereum address.
 */
async function ethereumAddressFromSigner(signer) {
    if (ethers_1.Signer.isSigner(signer)) {
        return address_1.EthereumAddress.from(await signer.getAddress());
    }
    else {
        return undefined;
    }
}
exports.ethereumAddressFromSigner = ethereumAddressFromSigner;
/**
 * Loads Ethereum implementation of tBTC core contracts for the given Ethereum
 * chain ID and attaches the given signer there.
 * @param signer Signer that should be attached to tBTC contracts.
 * @param chainId Ethereum chain ID.
 * @returns Handle to tBTC core contracts.
 * @throws Throws an error if the signer's Ethereum chain ID is other than
 *         the one used to load tBTC contracts.
 */
async function loadEthereumCoreContracts(signer, chainId) {
    const signerChainId = await chainIdFromSigner(signer);
    if (signerChainId !== chainId) {
        throw new Error("Signer uses different chain than Ethereum core contracts");
    }
    const bridge = new bridge_1.EthereumBridge({ signerOrProvider: signer }, chainId);
    const tbtcToken = new tbtc_token_1.EthereumTBTCToken({ signerOrProvider: signer }, chainId);
    const tbtcVault = new tbtc_vault_1.EthereumTBTCVault({ signerOrProvider: signer }, chainId);
    const walletRegistry = new wallet_registry_1.EthereumWalletRegistry({ signerOrProvider: signer }, chainId);
    return {
        bridge,
        tbtcToken,
        tbtcVault,
        walletRegistry,
    };
}
exports.loadEthereumCoreContracts = loadEthereumCoreContracts;
/**
 * Creates the Ethereum implementation of tBTC cross-chain contracts loader.
 * The provided signer is attached to loaded L1 contracts. The given
 * Ethereum chain ID is used to load the L1 contracts and resolve the chain
 * mapping that provides corresponding L2 chains IDs.
 * @param signer Ethereum L1 signer.
 * @param chainId Ethereum L1 chain ID.
 * @returns Loader for tBTC cross-chain contracts.
 * @throws Throws an error if the signer's Ethereum chain ID is other than
 *         the one used to construct the loader.
 */
async function ethereumCrossChainContractsLoader(signer, chainId) {
    const signerChainId = await chainIdFromSigner(signer);
    if (signerChainId !== chainId) {
        throw new Error("Signer uses different chain than Ethereum cross-chain contracts");
    }
    const loadChainMapping = () => contracts_1.ChainMappings.find((ecm) => ecm.ethereum === chainId);
    const loadL1Contracts = async (l2ChainName) => ({
        l1BitcoinDepositor: new l1_bitcoin_depositor_1.EthereumL1BitcoinDepositor({ signerOrProvider: signer }, chainId, l2ChainName),
    });
    return {
        loadChainMapping,
        loadL1Contracts,
    };
}
exports.ethereumCrossChainContractsLoader = ethereumCrossChainContractsLoader;
//# sourceMappingURL=index.js.map